<template>
  <div class="footer-box">
    <div class="footer-content">
      <div class="footer-left">
        <div class="footer-img">
          <img src="../assets/img/nav_logo.png" />
        </div>
        <div class="footer-public">
          <div class="public-left">
            <img src="../assets/img/yzs.jpg" />
            <div style="margin-top:10px" class="yzh-public">云征收官方公众号</div>
          </div>
          <div class="public-right">
            <img src="../assets/img/yz.jpg" />
            <div style="margin-top:10px">易征服务公众号</div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <ul class="footer-nav">
          <li class="footer-Products">
            <div class="footer-Products-en">Products</div>
            <div class="footer-Products-cn" @click="toOther('/product')">评估端</div>
            <div class="footer-Products-cn" @click="toOther('/whole')">全程端</div>
            <div class="footer-Products-cn" @click="toOther('/collection')">房屋征收综合管理系统</div>
            <div class="footer-Products-cn" @click="toOther('/gis')">GIS资产管理平台</div>
            <div class="footer-Products-cn" @click="toOther('/gisOther')">GIS一张图空间规划平台</div>
          </li>
          <li class="footer-Services">
            <div class="footer-Services-en">Services</div>
            <div class="footer-Services-cn" @click="toOther('/service')">无人机航拍服务</div>
            <div class="footer-Services-cn" @click="toOther('/process')">全流程征收服务</div>
            <div class="footer-Services-cn" @click="toOther('/management')">档案整理服务</div>
            <div class="footer-Services-cn" @click="toOther('/panoramic')">全景航拍服务</div>
          </li>
          <li class="footer-Cases">
            <div class="footer-Cases-en">Cases</div>
            <div
              class="footer-Cases-cn"
              v-for="(item,index) in caseList"
              :key="index"
              @click="toDetail(item.id)"
            >{{item.title}}</div>
          </li>
          <li class="footer-address">
            <div class="footer-address-en">联系方式：</div>
            <div class="footer-address-cn">深圳总部：深圳市南山区粤海街道高新区社区高新南七道015号深港产学研基地W106</div>
            <div class="footer-address-cn" style="padding-left: 70px;">134-1187-0085（张先生）</div>
            <div class="footer-address-cn" style="padding-left: 70px;">137-2421-0495（朱先生）</div>
            <!-- <div class="footer-address-cn" style="margin-top:41px">公司地址：</div> -->
            <div class="footer-address-cn">高校合作：150 1039 2789（李国平） 453391665@qq.com</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-title">
      <span> ©2011-{{nowData}}深圳房讯通信息技术有限公司版权所有&nbsp;&nbsp;&nbsp;</span>
      <el-link href="http://beian.miit.gov.cn" target="_blank" style="margin-left: 20px;height: 20px;color: #fff;" :underline="false">粤ICP备11010348号-6</el-link>
      <span style="margin-left:25px">粤公网安备44030502003886号</span>
      <el-link href="http://fxtcn.com/index_pc.html" target="_blank" style="margin-left: 20px;height: 20px;color: #fff;" :underline="false">关于我们</el-link>
    </div>
  </div>
</template>
<script>
import { queryOpertionPublicityByClient } from '../api/publicinquiry.api.js';
export default {
  name: 'Footer',
  data() {
    return {
      caseList: [],
      nowData: ''
    };
  },
  methods: {
    toOther(path) {
      this.$router.push(path);
    },
    getList() {
      let params = {
        pageNo: 1,
        pageSize: 3,
        type: 2
      };
      queryOpertionPublicityByClient(params).then(res => {
        this.caseList = res.data.list;
      });
    },
    toDetail(id) {
      this.$router.push({
        name: 'caseDetail',
        params: {
          Id: id
        }
      });
    }
  },
  created() {
    this.getList();
    this.nowData = new Date().getFullYear();
  }
};
</script>
<style>
.footer-box {
  background: rgb(32, 44, 57);
  width: 100%;
  /* position: fixed;
  bottom: 0;
  left: 0; */
}
.footer-content {
  width: 1500px;
  margin: auto;
  height: 360px;
  display: flex;
}
.footer-title {
  font-size: 14px;
  line-height: 60px;
  text-align: center;
  background: rgb(0, 0, 0);
  color: #ffffff;
}
.footer-title /deep/ .el-link.el-link--default:hover{
  color: #fff;
}
.footer-public {
  font-size: 14px;
  margin-top: 30px;
  display: flex;
}
.footer-img img {
  width: 142px;
  height: 50px;
  margin-top: 20px;
}
.public-left img {
  width: 100px;
  height: 100px;
}
.public-left {
  text-align: center;
  color: #ffffff;
}
.public-right img {
  width: 100px;
  height: 100px;
}
.public-right {
  text-align: center;
  color: #ffffff;
  margin-left: 50px;
}
.footer-nav {
  color: #ffffff;
  display: flex;
}
.footer-Products-en {
  line-height: 60px;
}
.footer-Products {
  margin-left: 87px;
}
.footer-Products-cn {
  font-size: 14px;
  line-height: 42px;
  cursor: pointer;
}
.footer-Services-en {
  line-height: 60px;
}
.footer-Services {
  /*margin-left: 80px;*/
  margin-left: 40px;
}
.footer-Services-cn {
  font-size: 14px;
  line-height: 42px;
  cursor: pointer;
}
.footer-Cases-en {
  line-height: 60px;
}
.footer-Cases {
  /*margin-left: 80px;*/
  margin-left: 40px;
}
.footer-Cases-cn {
  font-size: 14px;
  width: 150px;
  line-height: 42px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.footer-address {
  /*margin-left: 80px;*/
  margin-left: 40px;
}
.footer-address-en {
  margin-top: 20px;
}
.footer-address-cn {
  font-size: 14px;
  margin-top: 20px;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .footer-content {
    width: 1200px !important;
  }
  .footer-address {
    margin-left: 0px !important;
  }
  .footer-Services {
    margin-left: 30px !important;
  }
  .footer-Cases {
    margin-left: 35px!important;
    padding-right: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/footer.vue